import Animation from './animation'

/*
 * This animation is used when a random bar within the range is removed.
 */
class NonSlidingRangeChangeAnimation extends Animation {

  constructor (options) {
    super(options)
    this.twoPart = false
    this.ripple = false
  }

  match (serie) {
    if (!this.chart.previous) {
      return false // not an update
    }

    let r0 = this.chart.previous.layout.breakdown.range
      , r1 = this.chart.layout.breakdown.range

    return r1.length < r0.length
  }

  animate (serie, entering, selection, merged, exiting) {
    exiting.selection().data().forEach(d => {
      d._range = [0, 0]
    })

    exiting.duration(this.timing.duration * .1) // TODO Shrink it quickly for now until we sync x-axis transitions
           .tween('vertical', this.tweeners.vertical)
           .remove()

    merged.tween('all', this.tweeners.all)
          .tween('decorations', this.tweeners.decorations)
  }

}

export default NonSlidingRangeChangeAnimation
